export default __webpack_public_path__ + "static/media/record-survey.6f8d4ed1.png";